import { Box, useStyleConfig } from '@chakra-ui/react';

function Card(props: { variant?: string; children?: React.ReactNode; [x: string]: any }) {
	const { variant, children, ...rest } = props;
	const styles = useStyleConfig('Card', { variant });
	return (
		<Box __css={styles} {...rest}>
			{children}
		</Box>
	);
}

export default Card;
